<template>
  <div class="loading-indicator text-center">
    <b-spinner
      :class="{invisible: isInvisible}"
      label="Loading"
    />
  </div>
</template>

<script>
const DELAY_MSEC = 200;

export default {
  props: {
    useDelay: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      isSpinnerVisible: !this.useDelay,
      timeoutId: null,
    };
  },

  computed: {
    isInvisible() {
      return !this.isSpinnerVisible;
    },
  },

  created() {
    if(!this.isSpinnerVisible) {
      this.timeoutId = setTimeout(this.onTimeout, DELAY_MSEC);
    }
  },

  beforeDestroy() {
    if(this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  },

  methods: {
    onTimeout() {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
      this.isSpinnerVisible = true;
    },
  },
};
</script>
